import styled from 'styled-components';

const DeliveryTemplateStyle = styled.section`
	--radiusBorder: var(--sp4x);
	--paddingSelector: var(--sp2-5x);
	--gapSelector: var(--sp1-5x);
	--fontSizeSelector: 18px;
	--fontSizeIcon: var(--sp3x);
	--maxHeightDropdown: var(--sp35x);
	--paddingDropdownItem: var(--sp1-5x);
	--gapItemInfo: var(--sp0-5x);
	--paddingDropdown: var(--sp1x);
	--gapDropdownItem: var(--sp1-5x);

	--distanceTitleBottom: var(--sp5x);
	--dropdownBorderRadius: var(--sp1-5x);
	--dividerSpacing: var(--sp3x);
	--gapDeliveryBar: var(--sp2x);
	--marginActionsTop: var(--sp5x);
	--marginBottomSlotLabel: var(--sp1-5x);

	display: flex;
	flex-direction: column;
	width: 100%;

	&.is-sticky-dropdown {
		--distanceTitleBottom: 0;
		--marginActionsTop: var(--sp3x);
	}

	.dt-title {
		text-align: center;
		margin-bottom: var(--distanceTitleBottom);
	}

	.icon-pin,
	.icon-arrow,
	.item-icon {
		font-size: var(--fontSizeIcon);
		color: var(--neutral1000);
	}

	.icon-arrow {
		transform: rotate(90deg);
		transition: transform var(--trTime) ease-out;
		margin-left: auto;

		&.is-open {
			transform: rotate(270deg);
		}
	}

	.outside-wrapper-tabs {
		width: 100%;
		display: flex;
		justify-content: center;

		.wrapper-tabs {
			display: flex;
			gap: var(--sp0-5x);
			padding: var(--sp0-5x);
			border-radius: 100px;
			background: var(--neutral1000);
			width: fit-content;

			button {
				border: none !important;
			}
		}
	}

	input,
	.selector-text {
		font-size: var(--fontSizeSelector) !important;
		line-height: var(--lineHeightS) !important;

		&::placeholder {
			line-height: var(--lineHeightS) !important;
			font-size: var(--fontSizeSelector) !important;
		}
	}

	.selector-text {
		flex: 1;
		min-width: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.wrapper-selector {
		position: relative;
		width: 100%;
		overflow: visible;

		.selector-field {
			background-color: var(--neutral25) !important;
		}

		.selector-button,
		.selector-field {
			display: flex;
			align-items: center;
			gap: var(--gapSelector);
			width: 100%;
			padding: var(--paddingSelector);
			border-radius: var(--radiusBorder);
			cursor: pointer;
			background-color: var(--neutral25) !important;
		}
	}

	.selector-field {
		.selector-input-wrap {
			flex: 1;
			min-width: 0;
			margin: 0;

			.affix-wrapper,
			.base-input,
			input {
				padding: 0 !important;
				border: none;
				background: transparent;
				box-shadow: none;
				border-radius: 0 !important;
			}
		}
	}

	.wrapper-dropdown {
		position: absolute;
		top: calc(100% + var(--sp1x));
		left: 0;
		right: 0;
		z-index: 100000000000;
		padding: var(--paddingDropdown);
		max-height: var(--maxHeightDropdown);
		overflow-y: auto;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior: contain;
		border-radius: var(--dropdownBorderRadius);
		background: var(--mainColor);
		display: flex;
		flex-direction: column;
		gap: var(--gapDropdownItem);
		border: 1px solid var(--neutral200);
		width: 100%;
		max-width: 100%;
		box-sizing: border-box;

		.icon-pin {
			transform: translateY(calc((var(--p3) - var(--p3) * var(--lineHeight)) / -2));
		}
	}

	.form-item-label {
		label {
			font-size: var(--p4) !important;
			font-weight: 500 !important;
		}
	}

	.dropdown-item,
	.location-button {
		width: 100%;
		min-width: 100%;
		display: flex;
		gap: var(--gapSelector);
		padding: var(--paddingDropdownItem);
		border-radius: var(--sp1x);
		cursor: pointer;

		.item-info {
			display: flex;
			flex-direction: column;
			gap: var(--gapItemInfo);
			min-width: 0;
			overflow-wrap: anywhere;
		}

		&.active {
			background: var(--neutral25);
		}
	}

	.delivery-bar-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--gapDeliveryBar);
	}

	.location-button {
		display: flex;
		align-items: center;
	}

	.item-hours {
		display: flex;
		align-items: center;
		gap: var(--sp1x);
	}

	.item-status {
		color: var(--success1000);
	}

	.empty-state {
		padding: var(--sp3x) var(--sp2-5x);
		text-align: center;
	}

	.dt-selection-error {
		display: flex;
		align-items: center;
		gap: var(--sp1-5x);
		padding: var(--sp1-5x) var(--sp1-5x);
		border-radius: var(--sp1-5x);
	}

	.dt-selection-error-text {
		flex: 1;
		color: var(--error1000);
	}

	.dt-stale-address-warning {
		display: flex;
		align-items: center;
		gap: var(--sp1-5x);
		margin-top: var(--sp2x);
		padding: var(--sp1-5x) var(--sp2x);
		border-radius: var(--sp1-5x);
		background: var(--error100);
	}

	.dt-stale-address-icon {
		flex-shrink: 0;
		font-size: var(--sp3x);
		color: var(--error1000);
	}

	.dt-stale-address-text {
		flex: 1;
		color: var(--error1000);
	}

	.dt-stale-address-edit {
		flex-shrink: 0;
		padding: var(--sp1x) var(--sp2x);
		border-radius: var(--sp5x);
		border: none;
		background: var(--error1000);
		color: var(--mainColor);
		cursor: pointer;
		white-space: nowrap;
		transition: opacity var(--trTime) ease;

		&:hover {
			opacity: 0.85;
		}
	}

	/* Date / Time row */
	.dt-divider {
		border: none;
		border-radius: var(--sp10x);
		border-top: 1px solid var(--neutral300);
		margin: var(--dividerSpacing) 0;
	}

	.dt-slot-label {
		color: var(--neutral1000);
		margin-bottom: var(--marginBottomSlotLabel);
	}

	.dt-time-row {
		display: flex;
		gap: var(--gapSelector);

		> * {
			flex: 1;
			min-width: 0;
		}
	}

	.dt-select-wrap {
		position: relative;
		overflow: visible;
	}

	.dt-select-btn {
		width: 100%;
		display: flex;
		align-items: center;
		gap: var(--sp1x);
		padding: var(--form_inputPadTBL) var(--form_inputPadR) var(--form_inputPadTBL) var(--form_inputPadTBL);
		border-radius: var(--sp1x);
		background: var(--mainColor);
		border: 2px solid var(--neutral1000);
		cursor: pointer;
		text-align: left;
		transition: border-color var(--trTime) ease;

		&:disabled {
			opacity: 0.45;
			cursor: default;
		}
	}

	.dt-select-label {
		flex: 1;

		&.placeholder {
			opacity: 0.55;
		}
	}

	/* Actions — popup */
	.dt-actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--sp2x);
		flex-wrap: wrap;
		margin-top: var(--marginActionsTop);

		&.is-takeaway {
			justify-content: flex-end;
		}
	}

	.dt-action-right {
		display: flex;
		align-items: center;
		gap: var(--sp2x);
	}

	/* Sticky dropdown only */
	&.is-sticky-dropdown {
		overflow: visible;

		.delivery-bar-wrapper,
		.wrapper-selector,
		.dt-select-wrap {
			overflow: visible;
		}

		.dt-add-address {
			align-self: flex-start;
		}

		.dt-actions {
			flex-direction: column;
			align-items: stretch;
			gap: var(--sp3x);
			margin-top: var(--sp3x);
		}

		.dt-actions-primary {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: var(--sp3x);
			width: 100%;

			.btn.full {
				width: 100%;
			}
		}
	}

	.takeaway-phone-wrap {
		margin-top: var(--dividerSpacing);
	}

	.dt-time-row {
		.wrapper-dropdown {
			border: 2px solid var(--neutral1000);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--paddingSelector: var(--sp2x);
		--fontSizeSelector: var(--sp2x);
		--fontSizeIcon: var(--sp2x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--maxHeightDropdown: var(--sp20x);

		.takeaway-dropdown {
			--maxHeightDropdown: var(--sp40x);
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--maxHeightDropdown: var(--sp20x);

		.takeaway-dropdown {
			--maxHeightDropdown: var(--sp40x);
		}
	}

	/* //! Mobile — popup + sticky delivery */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--gapDropdownItem: var(--sp0-5x);
		--maxHeightDropdown: var(--sp20x);

		.takeaway-dropdown {
			--maxHeightDropdown: var(--sp30x);
		}

		.wrapper-dropdown {
			max-height: var(--maxHeightDropdown);
		}

		&:not(.is-sticky-dropdown) {
			.dt-time-row {
				flex-direction: column;
			}

			.dt-actions {
				flex-direction: column;
				align-items: stretch;
			}

			.dt-action-right {
				justify-content: center;
			}
		}
	}
`;

export default DeliveryTemplateStyle;
